import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import toast from 'react-hot-toast';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const { t } = useLanguage();

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!username || !password) {
      toast.error(t('login.enterCredentials'));
      return;
    }

    try {
      setIsLoading(true);
      await login(username, password);
      toast.success(t('login.success'));
      navigate('/dashboard');
    } catch (error) {
      console.error('Login error:', error);
      toast.error(error.response?.data?.message || t('login.failed'));
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-100 to-gray-200 py-12 px-4 sm:px-6 lg:px-8">
      <div className="absolute inset-0 bg-pattern bg-center opacity-5 pointer-events-none"></div>
      
      <div className="max-w-md w-full space-y-8 transition-all duration-300 ease-in-out transform hover:scale-[1.01]">
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden p-8">
          <div className="flex flex-col items-center">
            <img
              className="mx-auto h-28 w-auto drop-shadow-md transition-all duration-300 ease-in-out transform hover:scale-105"
              src="/libtamin.png"
              alt="Qirat Financial Services"
            />
            
            <h2 className="mt-6 text-center text-2xl font-bold text-purple-800">
              {t('login.title')}
          </h2>
            
            <p className="mt-2 text-center text-sm text-gray-600 max-w-xs">
              <span className="font-medium text-cyan-600">
                Qirat Financial Services and Consulting
              </span>
            </p>
        </div>
          
        <form className="mt-8 space-y-6" onSubmit={handleSubmit}>
            <div className="space-y-4">
            <div>
                <label htmlFor="username" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('login.username')}
              </label>
              <input
                id="username"
                name="username"
                type="text"
                required
                  className="appearance-none relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors duration-200 ease-in-out"
                  placeholder={t('login.username')}
                value={username}
                onChange={(e) => setUsername(e.target.value)}
              />
            </div>
              
            <div>
                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-1">
                  {t('login.password')}
              </label>
              <input
                id="password"
                name="password"
                type="password"
                autoComplete="current-password"
                required
                  className="appearance-none relative block w-full px-4 py-3 border border-gray-300 placeholder-gray-400 text-gray-900 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500 focus:border-purple-500 transition-colors duration-200 ease-in-out"
                  placeholder={t('login.password')}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          </div>

          <div>
            <button
              type="submit"
              disabled={isLoading}
                className={`group relative w-full flex justify-center py-3 px-4 border border-transparent text-sm font-medium rounded-lg text-white 
                  ${isLoading ? 'bg-purple-400 cursor-not-allowed' : 'bg-gradient-to-r from-purple-600 to-purple-800 hover:from-purple-700 hover:to-purple-900'} 
                  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-purple-500 transition-all duration-200 ease-in-out shadow-md hover:shadow-lg`}
            >
                {isLoading ? (
                  <span className="flex items-center">
                    <svg className="animate-spin -ml-1 mr-2 h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                      <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                    </svg>
                    {t('login.signingIn')}
                  </span>
                ) : t('login.signIn')}
            </button>
          </div>
        </form>
        </div>
        
        <div className="text-center mt-4">
          <p className="text-sm text-gray-600">
            &copy; {new Date().getFullYear()} Qirat - Insurance Management System
          </p>
        </div>
      </div>
    </div>
  );
}